// Subscription Plans Configuration
// These are relatively static configuration values for the application

export const SUBSCRIPTION_PLANS = [
    {
        id: 'basic',
        name: 'Basic',
        description: 'Perfect for small businesses getting started',
        price: 299,
        currency: 'AED',
        billingCycle: 'monthly',
        features: [
            'Up to 5 users',
            '1GB storage',
            'Basic reporting',
            'Email support',
            'Product management',
            'Order management',
            'Customer management'
        ],
        limits: {
            users: 5,
            storage: 1024, // MB
            products: 100,
            orders: 500
        },
        color: 'blue',
        popular: false
    },
    {
        id: 'standard',
        name: 'Standard',
        description: 'Ideal for growing businesses',
        price: 499,
        currency: 'AED',
        billingCycle: 'monthly',
        features: [
            'Up to 10 users',
            '5GB storage',
            'Advanced reporting',
            'Priority email support',
            'All Basic features',
            'Inventory management',
            'Staff management'
        ],
        limits: {
            users: 10,
            storage: 5120, // MB
            products: 500,
            orders: 2000
        },
        color: 'indigo',
        popular: true
    },
    {
        id: 'professional',
        name: 'Professional',
        description: 'For growing businesses with advanced needs',
        price: 799,
        currency: 'AED',
        billingCycle: 'monthly',
        features: [
            'Up to 25 users',
            '10GB storage',
            'Advanced reporting & analytics',
            'Priority email & chat support',
            'Product management',
            'Order management',
            'Customer management',
            'Staff management',
            'POS system',
            'Inventory tracking',
            'Custom notifications'
        ],
        limits: {
            users: 25,
            storage: 10240, // MB
            products: 1000,
            orders: 5000
        },
        color: 'purple',
        popular: true
    },
    {
        id: 'enterprise',
        name: 'Enterprise',
        description: 'For large organizations requiring full control',
        price: 1999,
        currency: 'AED',
        billingCycle: 'monthly',
        features: [
            'Unlimited users',
            '100GB storage',
            'Custom reporting & analytics',
            '24/7 phone & email support',
            'All Professional features',
            'Multi-location support',
            'Advanced security features',
            'API access',
            'Custom integrations',
            'Dedicated account manager',
            'Custom training'
        ],
        limits: {
            users: -1, // unlimited
            storage: 102400, // MB
            products: -1, // unlimited
            orders: -1 // unlimited
        },
        color: 'green',
        popular: false
    }
];

export const getPlanById = (planId) => {
    return SUBSCRIPTION_PLANS.find(plan => plan.id === planId);
};

export const getPlanColor = (planId) => {
    const plan = getPlanById(planId);
    return plan ? plan.color : 'gray';
};
